import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, browserHistory } from "react-router";
import {
  LazyLoadComponent,
  trackWindowScroll,
} from "common/components/lazy_load";
import Image from "common/components/image";
import { MKT_CLIENTS_COUNT } from "common/variables";
import Attribute from "marketing/common/attribute";
import SubcategorySelect from "common/containers/subcategory_select";
import { TitleSubcats } from "marketing/components/home_content";
import TrustedBy2 from "landing_pages/components/trusted_by_2";
import Categories2 from "landing_pages/components/categories_2";
import How4 from "landing_pages/components/how_4";
import Why2 from "landing_pages/components/why_2";
import Reviews2 from "landing_pages/containers/reviews_2";
import CaseStudies2 from "landing_pages/components/case_studies_2";
import Resources from "landing_pages/components/resources";
import Faq from "landing_pages/components/faq";
import Cta2 from "landing_pages/components/cta_2";

const POPULAR_SUBCATS = [
  { slug: "logo-design", name: "Logo design" },
  { slug: "website-design", name: "Website design" },
  { slug: "naming-a-business-or-product", name: "Company name" },
  { slug: "product-design", name: "Product design" },
  { slug: "packaging-design", name: "Packaging design" },
];

class HomeSubcatSelect extends Component {
  constructor(props) {
    super(props);

    this.state = { selectedId: null };

    this.getStarted = this.getStarted.bind(this);
  }

  getStarted(id) {
    const { subCategories } = this.props;
    if (id) {
      const subCat = subCategories.find((s) => s.id === id);
      browserHistory.push(`/${subCat.slug}/`);
    } else {
      browserHistory.push("/categories/");
    }
  }

  render() {
    const { subCategories } = this.props;
    const { selectedId } = this.state;

    return (
      <div className="sub-category-select-2">
        <SubcategorySelect
          meta={{}}
          value={selectedId}
          input={{
            name: "sub_category",
            onChange: (id) => this.setState({ selectedId: id }),
            placeholder: "What do you need?",
          }}
        />
        <button
          className="btn btn-tertiary"
          onClick={() => this.getStarted(selectedId)}
        >
          Get started
        </button>
        <div className="popular">
          <strong>Popular:</strong>
          {POPULAR_SUBCATS.map((item) => {
            const subcat = subCategories.find((s) => s.slug === item.slug);
            return (
              <span
                key={subcat.id}
                className="tag tag-default tag-sm"
                onClick={() => this.getStarted(subcat.id)}
              >
                {item.name}
              </span>
            );
          })}
        </div>
      </div>
    );
  }
}

HomeSubcatSelect.propTypes = {
  subCategories: PropTypes.array.isRequired,
};

const FAQS = [
  {
    question:
      "What's the advantage of using crowdspring over AI logo generators and other automated design tools?",
    answer:
      "There's a catch to the so-called 'free' logo makers: they offer bland, cookie-cutter generic designs that get lost rather than standing out. These generators lack the human touch—insight into emotion and psychology that only a professional designer can offer.<br/><br/>The pitch of whipping up a professional logo in mere seconds is a bit of a stretch. What you often get are low-resolution, uninspired images, and if you want high-resolution? That'll be extra, please, often with a monthly subscription that just keeps on taking and costs you thousands of dollars in the long run. These generic logos lack the uniqueness that makes a brand memorable. And you won't be able to trademark them.<br/><br/>Consider this: none of the top brands have used a free logo maker. They understand that a distinctive, professional design is invaluable. Sure, free sounds good, but if your logo looks cheap, it can do more damage than good, costing you more over time. With crowdspring, you get creativity, originality, and value—all in one.",
  },
  {
    question:
      "What makes crowdspring the better choice compared to other design options or agencies?",
    answer:
      "Crowdspring brings something special to the table that traditional agencies and freelance platforms don't: a whole world of creativity in one place. Since 2008, businesses big and small have landed high-quality logo designs, and other graphic, web, and product designs, thanks to our global community of top-notch creatives.<br/><br/>Our platform is like a worldwide design contest. With thousands of designers from over 195 countries competing, you're not just getting a custom design; you're choosing from dozens of custom-made options. Our process removes the hassle of negotiating prices or interviewing countless designers. You set your price, lay out your vision, and watch as designers submit their creations for your project.<br/><br/>In the end, you pick the winner, download your new design, and it's all yours to use as you please. Simple, stress-free, and with our 100% satisfaction guarantee, there's no risk—just great design.",
  },
  {
    question: "How much does a typical custom design project cost?",
    answer:
      "All our prices include an award, which goes directly to the winning creative and crowdspring's fee. When you post your project, you'll choose between 4 different packages: Silver, Gold, Elite and Platinum, each of which includes the award, our fee, and a set of features. Transparent pricing is our jam, so the only surprise you'll get is how awesome your project turns out. Logo designs, for instance, kick off at a neat $299, all-inclusive. No hidden fees, no fine print. Read our <a href='https://www.crowdspring.com/cost-of-design/' target='_blank'>guide on how much design costs</a> to understand your options.",
  },
  {
    question: "Will the design I choose be exclusively mine?",
    answer:
      "Absolutely. After you approve the final design, we settle up with the creative genius behind it, and voilà—you're the sole owner of the design's intellectual property. No ifs, ands, or buts. The rights are yours, and only yours. And you'll get a free written legal contract transferring intellectual property rights to you.",
  },
  {
    question:
      "How does crowdspring vet the designers and maintain high-quality work?",
    answer:
      "<a href='https://www.crowdspring.com/trust-and-security/' target='_blank'>Trust in our community</a> of creatives is paramount. That's why we're meticulous in selecting our designers—only a select few who apply make the cut. For the past eight years, we've kept our doors mostly closed, only opening them briefly to welcome small groups of new talent.<br/><br/>But our commitment to quality doesn't end at the door. We conduct regular, rigorous reviews of our designers' work to ensure they continue to meet our exacting standards in both their designs and their client interactions.<br/><br/>To give you a clear view of each designer's track record, we've developed a unique, industry-leading reputation system. It gives every creative a score between 1 and 100—think of it as a trust thermometer—giving you confidence in choosing the right designer for your project.",
  },
  {
    question: "How fast will I start seeing designs roll in?",
    answer:
      "Speed's the name of the game here at crowdspring. You could start seeing high-quality designs pop into your inbox in just a few hours. But most designs start coming after about a day. Typical projects take about a week from start to finish (but can be as short as 24 hour), and you're in the driver's seat—if you need more time, we'll extend your project's runway. And if you fall in love with a design right off the bat, we'll help you cross the finish line faster. You set the pace, we keep it smooth.",
  },
  {
    question: "Can I request unlimited revisions, or is there a cap?",
    answer:
      "When it comes to revisions, we don't believe in caps. Feel free to iterate and re-iterate with our designers until your heart's content and your design is just right. Even after you've chosen your favorite, we're all about fine-tuning to perfection during the project wrap-up phase. Your happiness is our finish line.",
  },
  {
    question: "Is there really a 100% money back guarantee?",
    answer:
      "You bet! If your design doesn't dazzle you, or your naming project gets fewer than 100 entries, we'll refund your money, no questions asked. We're committed to your happiness, and our guarantee is our handshake on that promise.",
  },
];

const HERO_TITLES = [
  null,
  <>
    The quality of a top design agency,
    <br className="show-for-large" /> at a fraction of the price.
  </>,
  <TitleSubcats
    key="title_subcats"
    omitPunctuation={true}
    content={({ currentSubcatIdx, subcat, link }) => (
      <>
        Grow your business faster with
        <br className="show-for-large" /> exceptional{" "}
        <br className="hide-for-large" />
        <Link key={currentSubcatIdx} to={link}>
          {subcat}
        </Link>
        .
      </>
    )}
  />,
  <>
    Unique designs that
    <br className="show-for-large" /> tell your unique story.
  </>,
  <>
    Become the brand
    <br className="show-for-large" /> everyone talks about.
  </>,
  <>
    Become the brand
    <br className="show-for-large" /> that's unforgettable.
  </>,
];

const HERO_SUBTITLES = [
  null,
  <>
    Over {MKT_CLIENTS_COUNT} businesses choose crowdspring for{" "}
    <strong>
      premium designs with speedy delivery,
      <br className="show-for-large" /> all without the hefty price tag.
    </strong>{" "}
    Because your brand deserves the best.
  </>,
  <>
    Join {MKT_CLIENTS_COUNT} businesses transforming their brand with
    crowdspring's custom designs.
    <br className="show-for-large" />{" "}
    <strong>Become the brand everyone talks about.</strong>
  </>,
  <>
    <strong>No algorithms, only pure creativity.</strong> Over{" "}
    {MKT_CLIENTS_COUNT} businesses have transformed their
    <br className="show-for-large" /> brand with crowdspring's tailored,
    handcrafted designs. <strong>Your brand deserves the best.</strong>
  </>,
  <>
    Over {MKT_CLIENTS_COUNT} businesses choose crowdspring for{" "}
    <strong>
      premium designs with speedy delivery,
      <br className="show-for-large" /> all without the hefty price tag.
    </strong>{" "}
    Because your brand deserves the best.
  </>,
  <>
    Over {MKT_CLIENTS_COUNT} businesses trust crowdspring for{" "}
    <strong>
      standout designs, delivered fast, all <br className="show-for-large" />
      without the hefty price tag.
    </strong>{" "}
    Because when it comes to your brand, only the best will do.
  </>,
];

const HomeContentVariations = (props) => {
  const { scrollPosition, variation } = props;

  return (
    <div className="home-content-variations">
      <section className="hero">
        <div className="row columns small-16 text-center">
          <h1>{HERO_TITLES[variation]}</h1>
          <h2>{HERO_SUBTITLES[variation]}</h2>
        </div>
        <div className="row">
          <div className="small-16 xlarge-10 xlarge-offset-1 columns">
            <HomeSubcatSelect {...props} />
          </div>
          <div className="small-16 xlarge-5 columns">
            <div className="artwork-container">
              <Image
                className="hero-art"
                src="blackfish-beer-company-hero.png"
                widths={[350]}
                alt="Blackfish Beer Company logo by miamiman"
              />
              <Attribute to="miamiman" />
            </div>
          </div>
        </div>
      </section>

      <TrustedBy2 />

      <Categories2 background="gray" />

      <How4 className="thick" />

      <LazyLoadComponent scrollPosition={scrollPosition}>
        <Why2 />
      </LazyLoadComponent>

      <Reviews2 />

      <LazyLoadComponent scrollPosition={scrollPosition}>
        <CaseStudies2 />
      </LazyLoadComponent>

      <LazyLoadComponent scrollPosition={scrollPosition}>
        <Resources background="gray" />
      </LazyLoadComponent>

      <LazyLoadComponent scrollPosition={scrollPosition}>
        <Faq questions={FAQS} title="FAQs" twoColumns={true} />
      </LazyLoadComponent>

      <LazyLoadComponent scrollPosition={scrollPosition}>
        <Cta2 />
      </LazyLoadComponent>
    </div>
  );
};

HomeContentVariations.propTypes = {
  scrollPosition: PropTypes.number,
  variation: PropTypes.number.isRequired,
};

export default trackWindowScroll(HomeContentVariations);
